module.exports = __webpack_public_path__ + "img/smart-scenic.ec39795c.jpg";